import { Injectable, NgZone } from "@angular/core";
import { Subscription } from "rxjs";

import { Calls as CallsStore } from "../../libraries/firebase/store/calls";
import { CallState } from "../../libraries/firebase/store/call-state";

import { AuthService, AuthState } from "./auth.service";

export { CallState };
export interface UserCallsState {
  calls: Array<CallState>;
}

@Injectable({ providedIn: "root" })
/**
 * This service listens to the call table in firestore
 * state contains an array of all calls in current org for the past 1 hour
 */
export class CallStoreHourlyService extends CallsStore {
  private authState: AuthState | undefined;
  protected unsubscriber = new Subscription();

  constructor(private auth: AuthService, private zone: NgZone) {
    super();
    this.subscribeAuth();
  }

  dispose(): void {
    this.unsubscriber.unsubscribe();
    super.dispose();
  }

  protected publishRun(fn: () => any): any {
    return this.zone.run(() => {
      return fn();
    });
  }

  private signedIn(): void {
    if (!this.authState) throw new Error("auth state undefined");
    if (!this.authState.oid) throw new Error("auth state oid undefined");
    if (!this.authState.aor) throw new Error("auth state aor undefined");
    const oid = this.authState.oid;
    const msInAHour = 60 * 60 * 1000;
    const offset = new Date(Date.now() - msInAHour);
    this.start(
      oid,
      [{ field: "created", op: ">", value: offset }],
      [{ field: "created", direction: "desc" }]
    );
  }

  private signedOut(): void {
    this.stop();
  }

  private subscribeAuth(): void {
    this.unsubscriber.add(
      this.auth.state.subscribe(state => {
        const didChange = AuthService.didAuthStatusChange(this.authState, state);
        this.authState = state;
        switch (didChange) {
          case "signedIn":
            return this.signedIn();
          case "signedOut":
            return this.signedOut();
          default:
            return;
        }
      })
    );
  }
}
